import { AccountInfo, IPublicClientApplication } from '@azure/msal-browser';

import { AxiosError } from 'axios';

import {
  call,
  put,
  takeEvery,
  CallEffect,
  PutEffect,
} from 'redux-saga/effects';

import apiUsers from 'api/users';

import { FETCH_USER, FETCH_USERS, INITIAL_FETCH_USER } from './types';
import { finishLoading, startLoading } from '../loading/actions';
import { setAccessToken, setMsalAccount, setMsalInstance } from './actions';

function* fetchUser() {
  try {
    yield put(startLoading(FETCH_USER.PENDING));
    const user = yield call(apiUsers.getCurrentUser);
    yield put({ type: FETCH_USER.SUCCESS, user });
    yield put(finishLoading(FETCH_USER.PENDING));
  } catch (error) {
    if (error.response.status === 401) {
      console.log(error.response);
      window.location.href = error.response.data.value.redirect;
    } else {
      yield put({ type: FETCH_USER.FAILURE, message: error.message });
    }
  }
}

function* initialFetchUser(action: {
  type: string;
  accessToken: null | string;
  msalInstance: null | IPublicClientApplication;
  msalAccount: null | AccountInfo;
}) {
  try {
    yield put(startLoading(INITIAL_FETCH_USER.PENDING));
    yield put(setAccessToken(action.accessToken));
    yield put(setMsalAccount(action.msalAccount));
    yield put(setMsalInstance(action.msalInstance));

    const user = yield call(apiUsers.getCurrentUser, true);

    yield put({ type: FETCH_USER.SUCCESS, user });
    yield put(finishLoading(INITIAL_FETCH_USER.PENDING));
  } catch (error) {
    if (error.response.status === 401) {
      console.log(error.response);
      window.location.href = error.response.data.value.redirect;
    } else {
      yield put({ type: INITIAL_FETCH_USER.FAILURE, message: error.message });
    }
  }
}

function* fetchUsers(): IterableIterator<CallEffect | PutEffect> {
  try {
    yield put(startLoading(FETCH_USERS.PENDING));
    const users = yield call(apiUsers.getAll);
    yield put({ type: FETCH_USERS.SUCCESS, users });
    yield put(finishLoading(FETCH_USERS.PENDING));
  } catch (error) {
    const axiosError = error as AxiosError;
    yield put({ type: FETCH_USERS.FAILURE, message: axiosError.message });
  }
}

function* saga() {
  yield takeEvery(FETCH_USER.PENDING, fetchUser);
  yield takeEvery(INITIAL_FETCH_USER.PENDING, initialFetchUser);
  yield takeEvery(FETCH_USERS.PENDING, fetchUsers);
}

export default saga;
